// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1f6eb1de","239":"ec09b6ec","455":"6ac747b8"}[chunkId] + ".chunk.js";
};